import { gql } from '@apollo/client';

export default gql`
  query getInvoicesByPurchaseOrder($purchaseOrderId: String) {
    getInvoicesByPurchaseOrder(purchaseOrderId: $purchaseOrderId) {
      ok
      message
      error
      data {
        _id
        docNo
        time
        title
        desc
        total
        discount
        amount
        profit
        supplierId
        supplierName
        supplierNameAr
        createdAt
        updatedAt
      }
    }
  }
`;
